import { useContext } from "react";
import { ParticipantContext } from "../contexts/Participant.context";
import { ParticipantContextProps } from "../models/contexts/participant-context.model";

export const useIsParticipantSyncableToMetriport = () => {
	const participantContext = useContext<ParticipantContextProps>(ParticipantContext);
	const participant = participantContext.participant!;

	const patientHasValidShippingAddress =
		participant.shippingAddressAddressLine1 &&
		participant.shippingAddressCity &&
		participant.shippingAddressState &&
		participant.shippingAddressPostalCode;

	const patientHasAllNecessaryData =
		participant.gender &&
		participant.dob &&
		participant.firstName &&
		participant.lastName &&
		patientHasValidShippingAddress;

	return Boolean(patientHasAllNecessaryData);
};
